/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import {
  ActionIcon as MantineActionIcon,
  type MantineTheme,
  createTheme,
  rem,
} from '@mantine/core';

import { colorToken, variablesToken } from '@fai/design-tokens';

export const actionIconTheme = createTheme({
  components: {
    ActionIcon: MantineActionIcon.extend({
      defaultProps: {
        variant: 'transparent',
      },
      vars: (_, props) => {
        if (props.variant === 'transparent') {
          return {
            root: {
              '--ai-bd': 'none',
            },
          };
        }

        if (props.variant === 'outline') {
          return {
            root: {
              '--ai-radius': variablesToken.radius.sm,
              '--ai-bd': `${rem(1)} solid ${colorToken.color.border.neutral.default}`,
              '--ai-bg': colorToken.color.fg.white,
              '--ai-hover': colorToken.color.bg.neutral.default.hover, // TODO: confirm with design
            },
          };
        }

        return {
          root: {},
        };
      },
    }),
  },
}) as MantineTheme;
